module.exports = __webpack_public_path__ + "static/img/1.4c3c0d0.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/2/5/zh/1.png
// module id = RcB7
// module chunks = 0